import Component from '@component';

export default class UserLoad extends Component {
	onInit(el) {
		this.el = el;
	}

	onReady() {
		if (window.sessionStorage.getItem('userLogin') === 'yes') {
			window.sessionStorage.removeItem('userLogin');
		}
		this.el.addEventListener('click', this.clickOnSignin.bind(this));
	}

	clickOnSignin() {
		window.sessionStorage.setItem('userLogin', 'yes');
	}
}
